interface WhiteCardProps {
  text: string;
  selected?: boolean;
  orderLabel?: number;
  onClick?: () => void;
  className?: string;
  compact?: boolean;
  testId?: string;
}

export function WhiteCard({ text, selected, orderLabel, onClick, className = '', compact = false, testId }: WhiteCardProps) {
  const Component = onClick ? 'button' : 'div';
  return (
    <Component
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      data-testid={testId}
      data-card-type="white"
      data-selected={selected ? 'true' : 'false'}
      data-order={orderLabel ?? undefined}
      aria-pressed={onClick ? Boolean(selected) : undefined}
      className={[
        compact ? 'w-36 h-48 md:w-40 md:h-52 p-4 shrink-0' : 'w-64 h-80 p-stack-md',
        'relative bg-white rounded-xl text-left card-shadow text-black flex flex-col justify-between transition-all duration-300',
        selected ? 'ring-4 ring-primary selected-glow -translate-y-4 z-10' : 'hover:-translate-y-3',
        className,
      ].join(' ')}
    >
      {orderLabel !== undefined && (
        <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-primary text-on-primary text-xs font-black w-7 h-7 rounded-full flex items-center justify-center shadow-lg">
          {orderLabel}
        </span>
      )}
      <p className={`font-card-text leading-snug overflow-y-auto break-words custom-scrollbar ${compact ? 'text-[15px]' : 'text-card-text'}`}>{text}</p>
      <span className="font-black text-surface/20 text-xs italic self-end">DAD</span>
    </Component>
  );
}
